(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/components/inline-message.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/components/inline-message.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const {
  ReactButton: Button
} = svs.ui;
const InlineMessage = _ref => {
  let {
    actions,
    header,
    icon,
    text,
    isError
  } = _ref;
  return React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement("div", {
    className: "u-text-center"
  }, icon && React.createElement(Icon, {
    className: "margin-bottom-1",
    color: "".concat(isError && 'fc-red'),
    icon: icon,
    size: "900"
  }), header && React.createElement("h2", {
    className: "h2"
  }, React.createElement("span", {
    className: "f-medium"
  }, header))), React.createElement("p", {
    className: "u-text-center"
  }, text), actions && (actions === null || actions === void 0 ? void 0 : actions.length) >= 1 && actions.map(action => React.createElement("div", {
    className: "margin-v-1 margin-top-2 align-center",
    key: action.text
  }, React.createElement(Button, {
    inverted: true,
    onClick: action.handleClick,
    size: 300
  }, action.text))));
};
svs.arena.shared.components.InlineMessage = InlineMessage;

 })(window);